import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { resultsContainer as styles } from '../styles';

const ColorSquare = props => {
  const { title, subtitle, icon, classes, className = '', subsubtitle } = props;

  return (
    <div className={classNames(classes.squareState, className)}>
      <div>{title}</div>
      <div>{subtitle}</div>
      <div>{icon}</div>
      {subsubtitle ? <div>{subsubtitle}</div> : ''}
    </div>
  );
};

ColorSquare.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ColorSquare);
